const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/published/v1/swimlane/$linkId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { publishedSwimlaneSearchSchema } from '@/components/views/published/PublishedSwimlanePage';

/**
 * Main published swimlane route.
 * This is the default public-facing view that renders the complete page
 * with header, footer, legend, and swimlane content.
 *
 * URL: /published/v1/swimlane/{linkId}
 *
 * Query Parameters:
 * - embed (optional): '1' to enable embed mode
 * - export (optional): '1' to enable export mode
 * - title (optional): '0' to hide title
 * - branding (optional): '0' to hide branding
 * - date (optional): '0' to hide publish date
 * - legend (optional): '0' to hide legend
 * - vision (optional): Custom vision statement text
 */
export const Route = createFileRoute('/(unauthenticated)/published/v1/swimlane/$linkId')({
  validateSearch: zodValidator(publishedSwimlaneSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});